var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-form-item',{attrs:{"label":_vm.$t('显示工号')}},[_c('el-switch',{model:{value:(_vm.data.showWokerNumber),callback:function ($$v) {_vm.$set(_vm.data, "showWokerNumber", $$v)},expression:"data.showWokerNumber"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }